export default __webpack_public_path__ + "static/media/promo third component.7d7ccc08.png";